export default class Bookmark {
  currentIndex: number = 0;
  score: number = 0;
  total: number = 0;
  biggestIndex: number = 0;
  lastSlideState?: any = {};
  version: string = '0';
  elapsedtime: string = '';

  constructor(
    currentIndex: number,
    score: number,
    total: number,
    biggestIndex: number,
    version: string,
    lastSlideState?: any
  ) {
    this.currentIndex = currentIndex;
    this.biggestIndex =
      biggestIndex < currentIndex ? currentIndex : biggestIndex;
    this.score = score;
    this.total = total;
    this.version = version;
    this.lastSlideState = lastSlideState;
  }

}
